import { render, staticRenderFns } from "./smtProtocol.vue?vue&type=template&id=15da2454&scoped=true"
import script from "./smtProtocol.vue?vue&type=script&lang=js"
export * from "./smtProtocol.vue?vue&type=script&lang=js"
import style0 from "./smtProtocol.vue?vue&type=style&index=0&id=15da2454&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15da2454",
  null
  
)

export default component.exports